export default __webpack_public_path__ + "static/media/logo.c534aa8e.png";